import { render, staticRenderFns } from "./EiBPlayer.vue?vue&type=template&id=4840adb3&scoped=true&"
import script from "./EiBPlayer.vue?vue&type=script&lang=js&"
export * from "./EiBPlayer.vue?vue&type=script&lang=js&"
import style0 from "./EiBPlayer.vue?vue&type=style&index=0&id=4840adb3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4840adb3",
  null
  
)

export default component.exports